<template>
  <div>
    <div v-if="settings&&settings.options.menuURL">
      <div v-if="iframeLoading" class="d-flex justify-center align-center" :style="{ height: wHeight + 'px' }">
        <v-progress-circular indeterminate size="80" width="6" color="black"></v-progress-circular>
      </div>
      <iframe
        :src="settings.options.menuURL"
        :style="{ width: '100%', height: iframeLoading ? '0' : wHeight + 'px', border: 'none', visibility: iframeLoading ? 'hidden' : 'visible' }"
        @load="iframeLoading = false"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Booking",
  props: {
    customerId: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: "Booking",
      stepper: 2,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      contentHeight: 0,
      loading: false,
      iframeLoading: true,
      activeTab: 0,
      dialog: false,
    }
  },
  
  computed: {
    ...mapGetters(['settings', 'countries']),
  },

  watch: {
    activeTab() {
      this.navigationStack = [];
    },    
    isActive: {
      immediate: true,  // Also check on initial mount
      handler(newVal) {
        // When tab becomes active and hasn't authenticated yet
        if (newVal && !this.hasAuthenticated) {
          this.getMenu()
        }
      }
    },   
  },

  mounted() {
    this.calculateContentHeight()
    window.addEventListener('resize', this.calculateContentHeight)
    window.addEventListener('orientationchange', this.calculateContentHeight)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateContentHeight)
    window.removeEventListener('orientationchange', this.calculateContentHeight)
  },

  methods: {
    /**
     * Calculate available height for scrollable content
     */
    calculateContentHeight() {
      this.wHeight = window.innerHeight
      
      // Get app bar height
      const appBar = document.querySelector('.v-app-bar')
      const appBarHeight = appBar ? appBar.offsetHeight : 50
      
      // Get system bar height (dev mode)
      const systemBar = document.querySelector('.v-system-bar')
      const systemBarHeight = systemBar ? systemBar.offsetHeight : 0
      
      // Tabs/breadcrumb height (sticky elements)
      const tabsHeight = this.navigationStack.length === 0 ? 68 : 56
      
      // Container padding (top + bottom)
      const containerPadding = 24
      
      // Margin/spacing for content
      const contentMargin = 16
      
      // Calculate available height for scrollable area
      this.contentHeight = this.wHeight - appBarHeight - systemBarHeight - tabsHeight - containerPadding - contentMargin
      
      // Minimum height fallback
      if (this.contentHeight < 300) {
        this.contentHeight = 300
      }
    },
  }
}

</script>
